<template lang="pug">
.row.form-group
  .col-sm-5
    ValidationProvider(
      v-slot="{ errors }"
      name="recurrence"
    )
      div(:class="{ 'has-error': errors[0] }")
        label.string.required.control-label
          | Resets
          abbr(title="required") *
        AppSelect#budget-attributes-recurrence(
          :select2-options="resetsSelect2Options"
          :options="budgetRecurrenceOptions"
          :value="budgetRecurrence"
          :disabled="disabled"
          @input="handleRecurrenceChange"
        )
        AppDialogError(:errors="errors")
  .col-sm-7(v-if="isBudgetRecurrenceWeekly")
    #recurrence-start-weekly.no-label-form-row
      ValidationProvider(
        v-slot="{ errors }"
        name="recurrence_start"
      )
        div(:class="{ 'has-error': errors[0] }")
          label.string.optional.control-label
          AppIntervalDayPicker#budget-attributes-recurrence-start.flex-sm-nowrap(
            mode="week"
            :multiple="false"
            :value="budgetRecurrenceStartSelectedWeekdays"
            :disabled="disabled"
            @input="handleRecurrenceStartWeekdayChange"
          )
          AppDialogError(:errors="errors")
  .col-sm-7(v-else-if="isBudgetRecurrenceMonthly")
    #recurrence-start-monthly(v-if="extendedResetOptions")
      ValidationProvider(
        v-slot="{ errors }"
        name="recurrence_start"
      )
        div(:class="{ 'has-error': errors[0] }")
          label.string.optional.control-label
            | On
          AppSelect#budget-attributes-recurrence-start(
            :select2-options="resetsSelect2Options"
            :options="recurrentStartMonthlyOptions"
            :value="budgetRecurrenceStart"
            :disabled="disabled"
            :async="false"
            @input="$emit('change-budget-field', 'recurrence_start', $event)"
          )
          AppDialogError(:errors="errors")
  .col-sm-7(v-else)
    ValidationProvider(
      v-slot="{ errors }"
      name="start_date"
    )
      div(:class="{ 'has-error': errors[0] }")
        .label-with-tooltip
          label.string.optional.control-label
            | Start date
          i.hi.hi-info.a-tooltip.ml-5(
            v-tooltip="startDateTooltipOptions"
            :title="startDateTooltip"
          )
        AppDatePicker#budget-attributes-start-date(
          :extra-picker-classes="'string'"
          :type="'daily'"
          :show-quick-pick="false"
          extra-input-classes="optional"
          :no-clear="noClear"
          :value="budgetStart"
          :disabled="disabled"
          @input="$emit('change-budget-field', 'start', $event)"
        )
        AppDialogError(:errors="errors")
</template>

<script>
import {
  BUDGET_RECURRENCE_WEEKLY,
  BUDGET_RECURRENCE_MONTHLY,
  BUDGET_RECURRENCE_OPTIONS,
  WO_BUDGET_RECURRENCE_OPTIONS,
} from '~/app_constants';

export default {
  name: 'BudgetRecurrenceRow',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    budgetState: {
      type: Object,
      required: true,
    },
    extendedResetOptions: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change-budget-field'],
  data() {
    return {
      defaultSelect2Options: {
        multiple: false,
        width: '100%',
        minimumResultsForSearch: -1,
      },
      startDateTooltip:
        'You can optionally set a start date, which will only take into account time tracked from the date forward.',
      startDateTooltipOptions: { container: 'body', placement: 'top' },
    };
  },
  computed: {
    budgetRecurrence() {
      return this.budgetState.recurrence;
    },
    budgetRecurrenceStart() {
      return this.budgetState.recurrence_start;
    },
    budgetRecurrenceStartSelectedWeekdays() {
      return [this.budgetState.recurrence_start];
    },
    budgetStart() {
      return this.budgetState.start;
    },
    isBudgetRecurrenceMonthly() {
      return this.budgetRecurrence === BUDGET_RECURRENCE_MONTHLY;
    },
    isBudgetRecurrenceWeekly() {
      return this.budgetRecurrence === BUDGET_RECURRENCE_WEEKLY;
    },
    budgetRecurrenceOptions() {
      return this.extendedResetOptions ? WO_BUDGET_RECURRENCE_OPTIONS : BUDGET_RECURRENCE_OPTIONS;
    },
    recurrentStartMonthlyOptions() {
      return Array(31)
        .fill()
        .map((_, i) => ({ id: i + 1, text: this.numberWithOrdinal(i + 1) + ' of the month' }));
    },
    resetsSelect2Options() {
      return { ...this.defaultSelect2Options, ...{ allowClear: false } };
    },
    noClear() {
      return !(this.budgetState && this.budgetState.start);
    },
  },
  methods: {
    numberWithOrdinal(number) {
      const suffixes = ['th', 'st', 'nd', 'rd'];
      const remainder = number % 100;

      return number + (suffixes[(remainder - 20) % 10] || suffixes[remainder] || suffixes[0]);
    },
    handleRecurrenceChange(val) {
      this.$emit('change-budget-field', 'recurrence', val);
      this.$emit('change-budget-field', 'recurrence_start', 1);
    },
    handleRecurrenceStartWeekdayChange(val) {
      this.$emit('change-budget-field', 'recurrence_start', val[0]);
    },
  },
};
</script>
